import axios from "axios";
import { context } from "../context/authContext";
import { useContext } from "react";

const getRoleKey = (roleName) => {
  const roleOptions = {
    2: "admin",
    3: "empleado",
    4: "cliente",
  };
  if (!isNaN(roleName)){
    return Number(roleName);
  }else {
    return Object.entries(roleOptions).find(([key, value]) => value === roleName)?.[0] || null;
  }
};

const useApi = () => {
  const { token } = useContext(context);

  const url = process.env.REACT_APP_ENVIRONMENT === "local" ? `http://localhost:${process.env.REACT_APP_PORT}` : process.env.REACT_APP_API_URL;

  return {
    login: async (data) => {
      try {
        const response = await axios.post(`${url}/api/v1/login`, data);
        return response.data;
      } catch (error) {
        return error;
      }
    },
    logs: async () =>{
      try {
        const response = await axios.get(`${url}/api/v1/logs`, { headers: { Authorization: `Bearer ${token}` }});
        return response.data;
      } catch (error) {
        return error;
      }
    },
    //ASIENTOS
    getAsientosBySala: async (sala) =>{
      return new Promise(async (res,rej)=>{
        try {
          const response = await axios.get(`${url}/api/v1/asientos?sala=${sala}`, { headers: { Authorization: `Bearer ${token}` }});
          res(response.data);
        } catch (error) {
          res(error.response.data);
        }
      })
    },
    createAsiento: async (asiento) =>{
      return new Promise(async (res,rej)=>{
        try {
          const response = await axios.post(`${url}/api/v1/asientos`,
            {
              numero:   asiento.numero, 
              x:        asiento.x,
              y:        asiento.y,
              width:    asiento.width,
              height:   asiento.height,
              row:      parseInt(asiento.row),
              column:   parseInt(asiento.column),
              rotation: asiento.rotation,
              sala:     parseInt(asiento.sala)
            }, { headers: { Authorization: `Bearer ${token}` }});
          res(response.data);
        } catch (error) {
          res(error.response.data);
        }
      })  
    },
    updateAsiento: async (asiento) =>{
      return new Promise(async (res,rej)=>{
        try {
          const response = await axios.patch(`${url}/api/v1/asientos/${asiento.id}`,
            {
              numero:   asiento.numero, 
              x:        asiento.x,
              y:        asiento.y,
              width:    asiento.width,
              height:   asiento.height,
              row:      parseInt(asiento.row),
              column:   parseInt(asiento.column),
              rotation: asiento.rotation,
              sala:     parseInt(asiento.sala)
            },{ headers: { Authorization: `Bearer ${token}` }});
          res(response.data);
        } catch (error) {
          res(error.response.data);
        }
      })
    },
    //Empresas
    getEmpresas : async () =>{
      return new Promise(async (res,rej)=>{
        try {
          const response = await axios.get(`${url}/api/v1/empresas`, { headers: { Authorization: `Bearer ${token}` }});
          res(response.data);
        } catch (error) {
          res(error.response.data);
        }
      })
    },
    updateEmpresa : async (empresa)=> {
      return new Promise(async (res,rej)=>{
        try {
          const response = await axios.patch(`${url}/api/v1/empresas/${empresa.id}`, {nombre:empresa.nombre},{ headers: { Authorization: `Bearer ${token}` }});
          res(response.data);
        } catch (error) {
          res(error.response.data);
        }
      })
    },
    createEmpresa : async (empresa)=> {
      return new Promise(async (res,rej)=>{
        try {
          const response = await axios.post(`${url}/api/v1/empresas`, empresa,{ headers: { Authorization: `Bearer ${token}` }});
          res(response.data);
        } catch (error) {
          res(error.response.data);
        }
      })
    },
    deleteEmpresa: async (id) =>{
      try {
        const response = await axios.delete(`${url}/api/v1/empresas/${id}`,{ headers: { Authorization: `Bearer ${token}` }});
        return response;
      } catch (error) {
        return error;
      }
    },
    //Productos
    getProductos : async () =>{
      return new Promise(async (res,rej)=>{
        try {
          const response = await axios.get(`${url}/api/v1/productos`, { headers: { Authorization: `Bearer ${token}` }});
          res(response.data);
        } catch (error) {
          res(error.response.data);
        }
      })
    },
    updateProducto : async (producto)=> {
      return new Promise(async (res,rej)=>{
        try {
          const response = await axios.patch(`${url}/api/v1/productos/${producto.id}`, 
            {...(producto.titulo && {titulo:producto.titulo}),
            ...(producto.id_woo && {id_woo:producto.id_woo}),
            ...(producto.duracion && {duracion:producto.duracion}),
            ...(producto.descripcion && {descripcion:producto.descripcion}),
            ...(producto.template && {template:producto.template}),
            ...(producto.desde && {desde:producto.desde}),
            ...(producto.hasta && {hasta:producto.hasta}),
            },{ headers: { Authorization: `Bearer ${token}` }});
          res(response.data);
        } catch (error) {
          res(error.response.data);
        }
      })
    },
    createProducto : async (producto)=> {
      return new Promise(async (res,rej)=>{
        try {
          const response = await axios.post(`${url}/api/v1/productos`, producto,{ headers: { Authorization: `Bearer ${token}` }});
          res(response.data);
        } catch (error) {
          res(error.response.data);
        }
      })
    },
    deleteProducto: async (id) =>{
      try {
        const response = await axios.delete(`${url}/api/v1/productos/${id}`,{ headers: { Authorization: `Bearer ${token}` }});
        return response;
      } catch (error) {
        return error;
      }
    },
    //SALAS
    getSalas : async () =>{
      return new Promise(async (res,rej)=>{
        try {
          const response = await axios.get(`${url}/api/v1/salas`, { headers: { Authorization: `Bearer ${token}` }});
          res(response.data);
        } catch (error) {
          res(error.response.data);
        }
      })
    },
    getSala : async (id) =>{
      return new Promise(async (res,rej)=>{
        try {
          const response = await axios.get(`${url}/api/v1/salas/${id}`, { headers: { Authorization: `Bearer ${token}` }});
          res(response.data);
        } catch (error) {
          res(error.response.data);
        }
      })
    },
    updateSala : async (sala)=> {
      return new Promise(async (res,rej)=>{
        try {
          const response = await axios.patch(`${url}/api/v1/salas/${sala.id}`, !!sala.nombre || !!sala.empresa ? {nombre:sala.nombre, empresa:sala.empresa} : sala,{ headers: { Authorization: `Bearer ${token}` }});
          res(response.data);
        } catch (error) {
          res(error.response.data);
        }
      })
    },
    createSala : async (sala)=> {
      return new Promise(async (res,rej)=>{
        try {
          const response = await axios.post(`${url}/api/v1/salas`, sala,{ headers: { Authorization: `Bearer ${token}` }});
          res(response.data);
        } catch (error) {
          res(error.response.data);
        }
      })
    },
    deleteSala: async (id) =>{
      try {
        const response = await axios.delete(`${url}/api/v1/salas/${id}`,{ headers: { Authorization: `Bearer ${token}` }});
        return response;
      } catch (error) {
        return error;
      }
    },
    //USUARIOS
    getUsuarios : async () =>{
      try {
        const response = await axios.get(`${url}/api/v1/usuarios`, { headers: { Authorization: `Bearer ${token}` }});
        return response.data;
      } catch (error) {
        return error;
      }
    },
    updateUsuario : async (usuario)=> {
      try {
        const response = await axios.patch(`${url}/api/v1/usuarios/${usuario.id}`, 
          {...(usuario.nombre && {nombre:usuario.nombre}),
          ...(usuario.email && {email:usuario.email}),
          ...(usuario.apellido && {apellido:usuario.apellido}),
          ...(usuario.dni && {dni:usuario.dni}),
          ...(usuario.direccion && {direccion:usuario.direccion}),
          ...(usuario.provincia && {provincia:usuario.provincia}),
          ...(usuario.ciudad && {ciudad:usuario.ciudad}),
          ...(usuario.cp && {cp:usuario.cp}),
          ...(usuario.telefono && {telefono:usuario.telefono}),
          ...(usuario.password && {password:usuario.password}),
          ...(usuario.rol && usuario.rol !== "superadmin" && {rol: getRoleKey(usuario.rol)}),
          ...((usuario.empresa && !isNaN(usuario.empresa*1)) && {empresa:usuario.empresa}),
        },{ headers: { Authorization: `Bearer ${token}` }});
        return response.data;
      } catch (error) {
        return error;
      }
    },
    createUsuario: async (usuario)=>{
      try {
        const response = await axios.post(`${url}/api/v1/usuarios`,usuario,{ headers: { Authorization: `Bearer ${token}` }});
        return response.data;
      } catch (error) {
        return error;
      }
    },
    borrarUsuario: async (id) =>{
      try {
        const response = await axios.delete(`${url}/api/v1/usuarios/${id}`,{ headers: { Authorization: `Bearer ${token}` }});
        return response;
      } catch (error) {
        return error;
      }
    },
    getRolesPermisos: async (idRol = null) =>{
      try {
        const response = await axios.get(`${url}/api/v1/roles-permisos${idRol ? `?rol=${idRol}` : '' }`, { headers: { Authorization: `Bearer ${token}` }});
        return response.data;
      } catch (error) {
        console.log(error)
        return error;
      }
    },
    getRoles: async () =>{
      try {
        const response = await axios.get(`${url}/api/v1/roles`, { headers: { Authorization: `Bearer ${token}` }});
        return response.data;
      } catch (error) {
        console.log(error)
        return error;
      }
    },
    getPermisos: async () =>{
      try {
        const response = await axios.get(`${url}/api/v1/permisos`, { headers: { Authorization: `Bearer ${token}` }});
        return response.data;
      } catch (error) {
        console.log(error)
        return error;
      }
    },
    createRolPermiso: async (rolPermiso) =>{
      try {
        const newModulo = await axios.post(`${url}/api/v1/modulos`,{nombre:rolPermiso.nombre, ruta: rolPermiso.ruta},{ headers: { Authorization: `Bearer ${token}` }});
        const roles = await axios.get(`${url}/api/v1/roles?nombre=${rolPermiso.rol}`,{ headers: { Authorization: `Bearer ${token}` }});
        const permisos = await axios.get(`${url}/api/v1/permisos`,{ headers: { Authorization: `Bearer ${token}` }});
        // const rol = roles.data.filter(rol=>rol.nombre === rolPermiso.rol).id;
        let response = []
        for(const permiso of permisos.data){
          if(rolPermiso[permiso.accion] === true){
            const newRolPermiso = await axios.post(`${url}/api/v1/roles-permisos`,
              { rol: roles.data[0].id , modulo: newModulo.data.id, permiso: permiso.id }, { headers: { Authorization: `Bearer ${token}` }});
              response.push(newRolPermiso.data)
          }
        }
        return response;
      } catch (error) {
        console.log(error)
        return error;
      }
    },
    updateRolPermiso: async (rolPermiso) => {
      try {
        let response = []
        const roles = await axios.get(`${url}/api/v1/roles?nombre=${rolPermiso.rol}`,{ headers: { Authorization: `Bearer ${token}` }});
        const permisos = await axios.get(`${url}/api/v1/permisos`,{ headers: { Authorization: `Bearer ${token}` }});
        for(const permiso of permisos.data){
          const getRolPermiso = await axios.get(`${url}/api/v1/roles-permisos?rol=${roles.data[0].id}&permiso=${permiso.id}&modulo=${rolPermiso.id}`, { headers: { Authorization: `Bearer ${token}` }});
          if(!rolPermiso[permiso.accion]){
            if(getRolPermiso.data.length !== 0){
              const deleteRolPermiso = await axios.delete(`${url}/api/v1/roles-permisos/${getRolPermiso.data[0].id}`, { headers: { Authorization: `Bearer ${token}` }})
              response.push(deleteRolPermiso.data)
            }
          } else{
            if(getRolPermiso.data.length === 0){
              const createRolPermiso = await axios.post(`${url}/api/v1/roles-permisos`, {rol:roles.data[0].id, permiso:permiso.id, modulo:rolPermiso.id}, { headers: { Authorization: `Bearer ${token}` }})
              response.push(createRolPermiso.data)
            }
          }
        }
        const updatedModulo = await axios.patch(`${url}/api/v1/modulos/${rolPermiso.id}`,{nombre:rolPermiso.nombre, ruta: rolPermiso.ruta},{ headers: { Authorization: `Bearer ${token}` }});
        response.push(updatedModulo.data)
        return response;
      } catch (error) {
        console.log(error)
        return error;
      }
    },
    deleteRolPermiso: async (rolPermiso) => {
      try {
        let response = []
        const roles = await axios.get(`${url}/api/v1/roles?nombre=${rolPermiso.rol}`,{ headers: { Authorization: `Bearer ${token}` }});
        const permisos = await axios.get(`${url}/api/v1/permisos`,{ headers: { Authorization: `Bearer ${token}` }});
        for(const permiso of permisos.data){
          const getRolPermiso = await axios.get(`${url}/api/v1/roles-permisos?rol=${roles.data[0].id}&permiso=${permiso.id}&modulo=${rolPermiso.id}`, { headers: { Authorization: `Bearer ${token}` }});
          if(getRolPermiso.data.length !== 0){
            const deleteRolPermiso = await axios.delete(`${url}/api/v1/roles-permisos/${getRolPermiso.data[0].id}`, { headers: { Authorization: `Bearer ${token}` }})
            response.push(deleteRolPermiso.data)
          }
        }
        const deletedModulo = await axios.delete(`${url}/api/v1/modulos/${rolPermiso.id}`,{ headers: { Authorization: `Bearer ${token}` }});
        response.push(deletedModulo.data)
        return response;
      } catch (error) {
        console.log(error)
        return error;
      }
    },
    //Templates
    getTemplates : async () =>{
      return new Promise(async (res,rej)=>{
        try {
          const response = await axios.get(`${url}/api/v1/templates`, { headers: { Authorization: `Bearer ${token}` }});
          res(response.data);
        } catch (error) {
          res(error.response.data);
        }
      })
    },
    getTemplate : async (id) =>{
      return new Promise(async (res,rej)=>{
        try {
          const response = await axios.get(`${url}/api/v1/templates/${id}`, { headers: { Authorization: `Bearer ${token}` }});
          res(response.data);
        } catch (error) {
          res(error.response.data);
        }
      })
    },
    updateTemplate : async (template)=> {
      return new Promise(async (res,rej)=>{
        try {
          const response = await axios.patch(`${url}/api/v1/templates/${template.id}`, 
            {...(template.nombre && {nombre: template.nombre}),
            ...(template.html && {html: template.html}),
            ...(template.css && {css: template.css}),
            ...(template.alto && {alto: template.alto}),
            ...(template.ancho && {ancho: template.ancho})
            },
            { headers: { Authorization: `Bearer ${token}` }});
          res(response.data);
        } catch (error) {
          res(error.response.data);
        }
      })
    },
    createTemplate : async (template)=> {
      return new Promise(async (res,rej)=>{
        try {
          const response = await axios.post(`${url}/api/v1/templates`, template,{ headers: { Authorization: `Bearer ${token}` }});
          res(response.data);
        } catch (error) {
          res(error.response.data);
        }
      })
    },
    deleteTemplate: async (id) =>{
      try {
        const response = await axios.delete(`${url}/api/v1/templates/${id}`,{ headers: { Authorization: `Bearer ${token}` }});
        return response;
      } catch (error) {
        return error;
      }
    },
    //INFORMES
    getComprasInforme: async () =>{
      return new Promise(async (res,rej)=>{
        try {
          const response = await axios.get(`${url}/api/v1/informes/compras`,{ headers: { Authorization: `Bearer ${token}` }});
          res(response.data);
        } catch (error) {
          res(error.response.data);
        }
      })
    },
    getEntradasInforme: async () =>{
      return new Promise(async (res,rej)=>{
        try {
          const response = await axios.get(`${url}/api/v1/informes/entradas`,{ headers: { Authorization: `Bearer ${token}` }});
          res(response.data);
        } catch (error) {
          res(error.response.data);
        }
      })
    },
    getZonaInforme: async () =>{
      return new Promise(async (res,rej)=>{
        try {
          const response = await axios.get(`${url}/api/v1/informes/zona`,{ headers: { Authorization: `Bearer ${token}` }});
          res(response.data);
        } catch (error) {
          res(error.response.data);
        }
      })
    },
    getProductoInforme: async () =>{
      return new Promise(async (res,rej)=>{
        try {
          const response = await axios.get(`${url}/api/v1/informes/producto`,{ headers: { Authorization: `Bearer ${token}` }});
          res(response.data);
        } catch (error) {
          res(error.response.data);
        }
      })
    },
    //TICKETS
    getTicket: async (ruta, token) =>{
      return new Promise(async(res, rej) => {
        try {
          const response = await axios.get(`${url}/api/v1/ticket/${ruta}`,{ headers: { Authorization: `Bearer ${token}` }, responseType: 'blob'});
          res(response.data);
        } catch (error) {
          res(error.response.data);
        }
      })
    },
    //MAIL
    reenviarMail: async(compra, token) =>{
      return new Promise(async(res, rej) => {
        try {
          const response = await axios.get(`${url}/api/v1/reenviar/${compra}`,{ headers: { Authorization: `Bearer ${token}` }});
          res(response);
        } catch (error) {
          res(error.response.data);
        }
      })
    },
  };
};

export default useApi;
